// Multi-country cities data - simplified version for quick implementation
export const citiesByCountry = {
  // Malaysia - using existing data structure
  MY: "EXISTING", // Placeholder - will use existing stateCities.js data
  
  // Singapore - major districts/areas
  SG: [
    {
      name: "Central",
      value: "Central",
      coord: "1.290453,103.851959",
      slug: "central",
      children: [
        { name: "Marina Bay", value: "Marina Bay", coord: "1.276387,103.854216", slug: "central-marinabay" },
        { name: "Raffles Place", value: "Raffles Place", coord: "1.283985,103.851441", slug: "central-rafflesplace" },
        { name: "Orchard", value: "Orchard", coord: "1.302279,103.837399", slug: "central-orchard" },
        { name: "Bugis", value: "Bugis", coord: "1.300316,103.856892", slug: "central-bugis" },
        { name: "Tanjong Pagar", value: "Tanjong Pagar", coord: "1.274377,103.843316", slug: "central-tanjongpagar" },
      ]
    },
    {
      name: "East",
      value: "East",
      coord: "1.343701,103.953359",
      slug: "east",
      children: [
        { name: "Tampines", value: "Tampines", coord: "1.352083,103.945833", slug: "east-tampines" },
        { name: "Bedok", value: "Bedok", coord: "1.324134,103.930052", slug: "east-bedok" },
        { name: "Pasir Ris", value: "Pasir Ris", coord: "1.372411,103.949348", slug: "east-pasirris" },
        { name: "Changi", value: "Changi", coord: "1.389660,103.987740", slug: "east-changi" },
      ]
    },
    {
      name: "North",
      value: "North",
      coord: "1.413587,103.835024",
      slug: "north",
      children: [
        { name: "Woodlands", value: "Woodlands", coord: "1.437080,103.786528", slug: "north-woodlands" },
        { name: "Yishun", value: "Yishun", coord: "1.429517,103.835170", slug: "north-yishun" },
        { name: "Sembawang", value: "Sembawang", coord: "1.448969,103.820041", slug: "north-sembawang" },
        { name: "Admiralty", value: "Admiralty", coord: "1.440689,103.800914", slug: "north-admiralty" },
      ]
    },
    {
      name: "Northeast",
      value: "Northeast",
      coord: "1.381098,103.886098",
      slug: "northeast",
      children: [
        { name: "Ang Mo Kio", value: "Ang Mo Kio", coord: "1.369720,103.849590", slug: "northeast-angmokio" },
        { name: "Hougang", value: "Hougang", coord: "1.371481,103.892494", slug: "northeast-hougang" },
        { name: "Sengkang", value: "Sengkang", coord: "1.391667,103.895000", slug: "northeast-sengkang" },
        { name: "Punggol", value: "Punggol", coord: "1.398328,103.907072", slug: "northeast-punggol" },
      ]
    },
    {
      name: "West",
      value: "West",
      coord: "1.347695,103.686995",
      slug: "west",
      children: [
        { name: "Jurong East", value: "Jurong East", coord: "1.333196,103.742302", slug: "west-jurongeast" },
        { name: "Jurong West", value: "Jurong West", coord: "1.340085,103.705935", slug: "west-jurongwest" },
        { name: "Clementi", value: "Clementi", coord: "1.314909,103.765245", slug: "west-clementi" },
        { name: "Bukit Batok", value: "Bukit Batok", coord: "1.358556,103.761773", slug: "west-bukitbatok" },
      ]
    },
  ],
  
  // Philippines - major cities grouped by region
  PH: [
    {
      name: "Metro Manila",
      value: "Metro Manila",
      coord: "14.5995,120.9842",
      slug: "metromanila",
      children: [
        { name: "Makati", value: "Makati", coord: "14.554729,121.024445", slug: "metromanila-makati" },
        { name: "Quezon City", value: "Quezon City", coord: "14.676041,121.043700", slug: "metromanila-quezoncity" },
        { name: "Manila", value: "Manila", coord: "14.599512,120.984222", slug: "metromanila-manila" },
        { name: "Pasig", value: "Pasig", coord: "14.587585,121.061691", slug: "metromanila-pasig" },
        { name: "Taguig", value: "Taguig", coord: "14.517587,121.050539", slug: "metromanila-taguig" },
        { name: "Mandaluyong", value: "Mandaluyong", coord: "14.579405,121.035213", slug: "metromanila-mandaluyong" },
        { name: "Paranaque", value: "Paranaque", coord: "14.479324,121.018866", slug: "metromanila-paranaque" },
        { name: "Caloocan", value: "Caloocan", coord: "14.649074,120.984695", slug: "metromanila-caloocan" },
      ]
    },
    {
      name: "Cebu",
      value: "Cebu",
      coord: "10.3157,123.8854",
      slug: "cebu",
      children: [
        { name: "Cebu City", value: "Cebu City", coord: "10.315699,123.885437", slug: "cebu-cebucity" },
        { name: "Mandaue", value: "Mandaue", coord: "10.323574,123.922328", slug: "cebu-mandaue" },
        { name: "Lapu-Lapu", value: "Lapu-Lapu", coord: "10.311111,123.949444", slug: "cebu-lapulapu" },
      ]
    },
    {
      name: "Davao",
      value: "Davao",
      coord: "7.1907,125.4553",
      slug: "davao",
      children: [
        { name: "Davao City", value: "Davao City", coord: "7.190708,125.455341", slug: "davao-davaocity" },
        { name: "Tagum", value: "Tagum", coord: "7.448167,125.807778", slug: "davao-tagum" },
      ]
    },
    {
      name: "Baguio",
      value: "Baguio",
      coord: "16.4023,120.5960",
      slug: "baguio",
      children: [
        { name: "Baguio City", value: "Baguio City", coord: "16.402333,120.596007", slug: "baguio-baguiocity" },
      ]
    },
    {
      name: "Cagayan de Oro",
      value: "Cagayan de Oro",
      coord: "8.4822,124.6467",
      slug: "cagayandeoro",
      children: [
        { name: "Cagayan de Oro City", value: "Cagayan de Oro City", coord: "8.482196,124.646743", slug: "cagayandeoro-cdocity" },
      ]
    },
    {
      name: "Iloilo",
      value: "Iloilo",
      coord: "10.7202,122.5621",
      slug: "iloilo",
      children: [
        { name: "Iloilo City", value: "Iloilo City", coord: "10.720217,122.562106", slug: "iloilo-iloilocity" },
      ]
    },
    {
      name: "Bacolod",
      value: "Bacolod",
      coord: "10.6407,122.9688",
      slug: "bacolod",
      children: [
        { name: "Bacolod City", value: "Bacolod City", coord: "10.640691,122.968859", slug: "bacolod-bacolodcity" },
      ]
    },
    {
      name: "Batangas",
      value: "Batangas",
      coord: "13.7565,121.0583",
      slug: "batangas",
      children: [
        { name: "Batangas City", value: "Batangas City", coord: "13.756481,121.058308", slug: "batangas-batangascity" },
        { name: "Lipa", value: "Lipa", coord: "13.941399,121.164218", slug: "batangas-lipa" },
      ]
    },
    {
      name: "Pampanga",
      value: "Pampanga",
      coord: "15.0794,120.6200",
      slug: "pampanga",
      children: [
        { name: "San Fernando", value: "San Fernando", coord: "15.033807,120.684656", slug: "pampanga-sanfernando" },
        { name: "Angeles", value: "Angeles", coord: "15.145139,120.588611", slug: "pampanga-angeles" },
      ]
    },
    {
      name: "Laguna",
      value: "Laguna",
      coord: "14.2691,121.4113",
      slug: "laguna",
      children: [
        { name: "Santa Rosa", value: "Santa Rosa", coord: "14.312222,121.111389", slug: "laguna-santarosa" },
        { name: "Calamba", value: "Calamba", coord: "14.211667,121.165278", slug: "laguna-calamba" },
      ]
    },
    {
      name: "Cavite",
      value: "Cavite",
      coord: "14.4791,120.8970",
      slug: "cavite",
      children: [
        { name: "Dasmarinas", value: "Dasmarinas", coord: "14.299308,120.936545", slug: "cavite-dasmarinas" },
        { name: "Bacoor", value: "Bacoor", coord: "14.458111,120.928417", slug: "cavite-bacoor" },
      ]
    },
  ],
  
  // Indonesia - major cities organized by province
  ID: [
    {
      name: "DKI Jakarta",
      value: "DKI Jakarta",
      coord: "-6.208763,106.845599",
      slug: "dki-jakarta",
      children: [
        { name: "Jakarta Pusat", value: "Jakarta Pusat", coord: "-6.1805,106.8283", slug: "dki-jakarta-pusat" },
        { name: "Jakarta Utara", value: "Jakarta Utara", coord: "-6.1481,106.9006", slug: "dki-jakarta-utara" },
        { name: "Jakarta Barat", value: "Jakarta Barat", coord: "-6.1674,106.7637", slug: "dki-jakarta-barat" },
        { name: "Jakarta Selatan", value: "Jakarta Selatan", coord: "-6.2615,106.8106", slug: "dki-jakarta-selatan" },
        { name: "Jakarta Timur", value: "Jakarta Timur", coord: "-6.2250,106.9004", slug: "dki-jakarta-timur" },
      ]
    },
    {
      name: "Jawa Barat",
      value: "Jawa Barat",
      coord: "-6.914894,107.609810",
      slug: "jawa-barat",
      children: [
        { name: "Bandung", value: "Bandung", coord: "-6.917464,107.619123", slug: "jawa-barat-bandung" },
        { name: "Bekasi", value: "Bekasi", coord: "-6.241586,106.992416", slug: "jawa-barat-bekasi" },
        { name: "Depok", value: "Depok", coord: "-6.402484,106.794241", slug: "jawa-barat-depok" },
        { name: "Bogor", value: "Bogor", coord: "-6.597147,106.806040", slug: "jawa-barat-bogor" },
        { name: "Cimahi", value: "Cimahi", coord: "-6.872174,107.542510", slug: "jawa-barat-cimahi" },
      ]
    },
    {
      name: "Jawa Tengah",
      value: "Jawa Tengah",
      coord: "-7.025253,110.445809",
      slug: "jawa-tengah",
      children: [
        { name: "Semarang", value: "Semarang", coord: "-6.966667,110.416667", slug: "jawa-tengah-semarang" },
        { name: "Solo", value: "Solo", coord: "-7.556480,110.831670", slug: "jawa-tengah-solo" },
        { name: "Salatiga", value: "Salatiga", coord: "-7.331730,110.500280", slug: "jawa-tengah-salatiga" },
        { name: "Pekalongan", value: "Pekalongan", coord: "-6.888060,109.674910", slug: "jawa-tengah-pekalongan" },
      ]
    },
    {
      name: "Jawa Timur",
      value: "Jawa Timur",
      coord: "-7.536064,112.238402",
      slug: "jawa-timur",
      children: [
        { name: "Surabaya", value: "Surabaya", coord: "-7.257472,112.752088", slug: "jawa-timur-surabaya" },
        { name: "Malang", value: "Malang", coord: "-7.966620,112.632632", slug: "jawa-timur-malang" },
        { name: "Sidoarjo", value: "Sidoarjo", coord: "-7.447313,112.716839", slug: "jawa-timur-sidoarjo" },
        { name: "Gresik", value: "Gresik", coord: "-7.193669,112.552734", slug: "jawa-timur-gresik" },
      ]
    },
    {
      name: "DI Yogyakarta",
      value: "DI Yogyakarta",
      coord: "-7.795580,110.369490",
      slug: "di-yogyakarta",
      children: [
        { name: "Kota Yogyakarta", value: "Kota Yogyakarta", coord: "-7.795580,110.369490", slug: "di-yogyakarta-kota" },
        { name: "Sleman", value: "Sleman", coord: "-7.716165,110.355465", slug: "di-yogyakarta-sleman" },
        { name: "Bantul", value: "Bantul", coord: "-7.919017,110.378540", slug: "di-yogyakarta-bantul" },
      ]
    },
    {
      name: "Banten",
      value: "Banten",
      coord: "-6.405817,106.064018",
      slug: "banten",
      children: [
        { name: "Tangerang", value: "Tangerang", coord: "-6.202394,106.652710", slug: "banten-tangerang" },
        { name: "Tangerang Selatan", value: "Tangerang Selatan", coord: "-6.283522,106.711299", slug: "banten-tangerang-selatan" },
        { name: "Serang", value: "Serang", coord: "-6.110366,106.163975", slug: "banten-serang" },
        { name: "Cilegon", value: "Cilegon", coord: "-6.002530,106.011120", slug: "banten-cilegon" },
      ]
    },
    {
      name: "Sumatera Utara",
      value: "Sumatera Utara",
      coord: "3.597031,98.678513",
      slug: "sumatera-utara",
      children: [
        { name: "Medan", value: "Medan", coord: "3.595196,98.672226", slug: "sumatera-utara-medan" },
        { name: "Binjai", value: "Binjai", coord: "3.600494,98.485426", slug: "sumatera-utara-binjai" },
        { name: "Pematangsiantar", value: "Pematangsiantar", coord: "2.959669,99.068670", slug: "sumatera-utara-pematangsiantar" },
      ]
    },
    {
      name: "Sumatera Barat",
      value: "Sumatera Barat",
      coord: "-0.947083,100.417181",
      slug: "sumatera-barat",
      children: [
        { name: "Padang", value: "Padang", coord: "-0.947083,100.417181", slug: "sumatera-barat-padang" },
        { name: "Bukittinggi", value: "Bukittinggi", coord: "-0.305556,100.369167", slug: "sumatera-barat-bukittinggi" },
      ]
    },
    {
      name: "Sumatera Selatan",
      value: "Sumatera Selatan",
      coord: "-2.991442,104.756554",
      slug: "sumatera-selatan",
      children: [
        { name: "Palembang", value: "Palembang", coord: "-2.991442,104.756554", slug: "sumatera-selatan-palembang" },
        { name: "Prabumulih", value: "Prabumulih", coord: "-3.421400,104.246900", slug: "sumatera-selatan-prabumulih" },
      ]
    },
    {
      name: "Riau",
      value: "Riau",
      coord: "0.507068,101.447777",
      slug: "riau",
      children: [
        { name: "Pekanbaru", value: "Pekanbaru", coord: "0.507068,101.447777", slug: "riau-pekanbaru" },
        { name: "Dumai", value: "Dumai", coord: "1.680279,101.400208", slug: "riau-dumai" },
      ]
    },
    {
      name: "Kepulauan Riau",
      value: "Kepulauan Riau",
      coord: "0.153754,104.580376",
      slug: "kepulauan-riau",
      children: [
        { name: "Batam", value: "Batam", coord: "1.045625,104.030457", slug: "kepulauan-riau-batam" },
        { name: "Tanjung Pinang", value: "Tanjung Pinang", coord: "0.906520,104.455840", slug: "kepulauan-riau-tanjungpinang" },
      ]
    },
    {
      name: "Lampung",
      value: "Lampung",
      coord: "-5.450000,105.266670",
      slug: "lampung",
      children: [
        { name: "Bandar Lampung", value: "Bandar Lampung", coord: "-5.450000,105.266670", slug: "lampung-bandarlampung" },
        { name: "Metro", value: "Metro", coord: "-5.113400,105.306900", slug: "lampung-metro" },
      ]
    },
    {
      name: "Bali",
      value: "Bali",
      coord: "-8.340539,115.091951",
      slug: "bali",
      children: [
        { name: "Denpasar", value: "Denpasar", coord: "-8.670458,115.212629", slug: "bali-denpasar" },
        { name: "Badung", value: "Badung", coord: "-8.581930,115.177020", slug: "bali-badung" },
        { name: "Gianyar", value: "Gianyar", coord: "-8.544210,115.325490", slug: "bali-gianyar" },
      ]
    },
    {
      name: "Kalimantan Timur",
      value: "Kalimantan Timur",
      coord: "-0.502106,117.153709",
      slug: "kalimantan-timur",
      children: [
        { name: "Samarinda", value: "Samarinda", coord: "-0.502106,117.153709", slug: "kalimantan-timur-samarinda" },
        { name: "Balikpapan", value: "Balikpapan", coord: "-1.237250,116.852830", slug: "kalimantan-timur-balikpapan" },
      ]
    },
    {
      name: "Kalimantan Selatan",
      value: "Kalimantan Selatan",
      coord: "-3.319537,114.594376",
      slug: "kalimantan-selatan",
      children: [
        { name: "Banjarmasin", value: "Banjarmasin", coord: "-3.319537,114.594376", slug: "kalimantan-selatan-banjarmasin" },
        { name: "Banjarbaru", value: "Banjarbaru", coord: "-3.456960,114.840279", slug: "kalimantan-selatan-banjarbaru" },
      ]
    },
    {
      name: "Sulawesi Selatan",
      value: "Sulawesi Selatan",
      coord: "-5.147665,119.432732",
      slug: "sulawesi-selatan",
      children: [
        { name: "Makassar", value: "Makassar", coord: "-5.147665,119.432732", slug: "sulawesi-selatan-makassar" },
        { name: "Palopo", value: "Palopo", coord: "-3.000000,120.200000", slug: "sulawesi-selatan-palopo" },
      ]
    },
    {
      name: "Sulawesi Utara",
      value: "Sulawesi Utara",
      coord: "1.493050,124.841068",
      slug: "sulawesi-utara",
      children: [
        { name: "Manado", value: "Manado", coord: "1.493050,124.841068", slug: "sulawesi-utara-manado" },
        { name: "Bitung", value: "Bitung", coord: "1.440790,125.182190", slug: "sulawesi-utara-bitung" },
      ]
    },
    {
      name: "Nusa Tenggara Barat",
      value: "Nusa Tenggara Barat",
      coord: "-8.583333,116.116667",
      slug: "nusa-tenggara-barat",
      children: [
        { name: "Mataram", value: "Mataram", coord: "-8.583333,116.116667", slug: "nusa-tenggara-barat-mataram" },
        { name: "Bima", value: "Bima", coord: "-8.460556,118.726944", slug: "nusa-tenggara-barat-bima" },
      ]
    },
    {
      name: "Papua",
      value: "Papua",
      coord: "-2.533000,140.717000",
      slug: "papua",
      children: [
        { name: "Jayapura", value: "Jayapura", coord: "-2.533000,140.717000", slug: "papua-jayapura" },
        { name: "Merauke", value: "Merauke", coord: "-8.493330,140.401670", slug: "papua-merauke" },
      ]
    },
  ],
};

// Helper function to get cities by country and state
export const getCitiesByCountry = (countryCode) => {
  if (countryCode === 'MY') {
    // Return existing Malaysian cities data
    const stateCities = require('./stateCities').default;
    return stateCities;
  }
  return citiesByCountry[countryCode] || [];
};

// Helper function to get cities for all countries (for backward compatibility)
export const getAllCitiesByCountry = (countryCode) => {
  return getCitiesByCountry(countryCode);
};

// Export default for backward compatibility
export default citiesByCountry;